module.exports = global["I18n"] = require("-!./i18n.js");


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/i18n-js/app/assets/javascripts/i18n.js
// module id = PU6p
// module chunks = 19